import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const navLinks = [
    { href: '/', label: '首页' },
    { href: '/category/jue-se-ban-yan', label: 'AI角色扮演' },
    { href: '/category/xu-ni-lian-ren', label: '虚拟恋人' },
    { href: '/category/qing-gan-dui-hua', label: '情感对话' },
    { href: '/about', label: '关于我们' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/50'
          : 'bg-transparent'
      }`}
    >
      <nav className="max-w-7xl mx-auto px-4 md:px-6" aria-label="主导航">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 text-xl font-bold font-heading text-foreground-950 hover:text-primary-500 transition-colors duration-200"
          >
            <span className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
              <i className="ri-heart-line text-background-50 text-sm"></i>
            </span>
            AI风月
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`px-4 py-2 text-sm rounded-full transition-all duration-200 whitespace-nowrap ${
                  location.pathname === link.href
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-700 hover:text-primary-500 hover:bg-primary-50'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className="px-5 py-2 text-sm font-medium rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap"
            >
              开始体验
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 transition-colors duration-200"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="切换菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden pb-4 border-t border-background-200/50 pt-3">
            <div className="flex flex-col gap-1">
              {navLinks.map((link) => (
                <Link
                  key={link.href}
                  to={link.href}
                  className={`px-4 py-3 text-sm rounded-lg transition-all duration-200 ${
                    location.pathname === link.href
                      ? 'bg-primary-500 text-background-50'
                      : 'text-foreground-700 hover:bg-background-100'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
              <Link
                to="/about"
                className="mt-2 mx-4 px-5 py-2.5 text-sm font-medium text-center rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors duration-200"
              >
                开始体验
              </Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}